import React, { useCallback, useState } from 'react'
import { Button, Modal, Grid, TextArea,Dropdown } from 'semantic-ui-react'
import { useEvent } from '@hooks/useEvent';
import DropDown from "@commonComponents/formComponents/CustomDropDown";


const CertDropdownModal = ({ open, onClose, selectedType, onSubmit,apiData, updateWarehouseID }) => {
  const { saveForm } = useEvent('headerTab')

  const [isOpen, setIsOpen] = useState(false)
  const [observationText, setObservationText] = useState('')
  const [disabled, setDisabled] = useState(true); 
  const [generateButtonEnabled, setGenerateButtonEnabled] = useState(false); 
  const [warehouseID, setWarehouseID] = useState('');  
  const [errorMessage, setErrorMessage] = useState('Please Select WarehouseID in order to generate the Document');



  let dynamicButtonName = selectedType === 'RMT' ? 'Matricula': 'Observation'


const vWarehouses = apiData?.filter(item => item?.whType === "V") || [];

const errorMessageText = "Please select Warehouse ID in order to generate the Document"


  const closeModal = () => {
    setIsOpen(false)
    setObservationText('');
    setWarehouseID('');
      setDisabled(true);
      setGenerateButtonEnabled(false)
  }

  const handleCancel = () => {
    onClose()
    closeModal()
  }

  const handleSubmit = async () => {
    await onSubmit(selectedType)
    onClose()
    closeModal()
  }

  const ontextSubmit = async () => {
    await saveForm({ observation: {[selectedType?.toLowerCase()] : observationText} })
    setGenerateButtonEnabled(true);
  }

  const handleProceedWithoutObservation = async () => {
    await saveForm({ observation:{[selectedType?.toLowerCase()] : ' ' }}); 
    setGenerateButtonEnabled(true);

  };


  const handleTextAreaChange = (e, { value }) => {
    setObservationText(value)
    setDisabled(value.trim() === '')
  }

  

  const onSelectWarehouseID = (event, { value }) => {
    setWarehouseID(value);
    setErrorMessage(value.trim() === '' ? errorMessageText : '');
    updateWarehouseID(value)
  };


  return (
    <Modal id='certDropdownModal' className='cancelNcts' open={open}>
      <Modal.Header>{`Generate ${selectedType} Document`}</Modal.Header>
      <Modal.Content>
        <Grid>
          {selectedType === 'LAME' && (
            <Grid.Row>
              <Grid.Column>
                <DropDown
                  id='warehouseID'
                  label={'WarehouseID'}
                  labelClass='text-none'
                  data={vWarehouses?.map((item) => ({
                    key: item.id,
                    text: item.warehouseID,
                    text_es: item.warehouseID,
                    value: item.warehouseID,
                  }))}
                  value={warehouseID}
                  onChange={onSelectWarehouseID}
                  isDisabled={false}
                />
                {(!warehouseID || warehouseID.trim() === '') && open && (
                  <p style={{ color: 'red' }}>{errorMessageText}</p>
                )}
              </Grid.Column>
            </Grid.Row>
          )}

          <Grid.Row>
            <Grid.Column>
              <TextArea
                style={{ width: '600px', height: '100px', resize: 'none' }}
                label={`Observation`}
                placeholder='You can Enter 1024 Characters'
                value={observationText}
                onChange={handleTextAreaChange}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className='button-container'>
                <Button primary id='saveObservation' onClick={ontextSubmit} disabled={disabled}>
                  {`Save ${dynamicButtonName}`}
                </Button>
                <Button primary id='withoutObservation' onClick={handleProceedWithoutObservation}>
                  {`Proceed Without ${dynamicButtonName}`}
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color='blue' id='cancelbtn' onClick={handleCancel}>
          Cancel
        </Button>

        <Button
          id='submit'
          primary
          onClick={handleSubmit}
          disabled={
            !generateButtonEnabled ||
            (selectedType === 'LAME' && (!warehouseID || warehouseID.trim() === ''))
              ? true
              : false
          }
        >
          {`Generate ${selectedType} Document`}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default CertDropdownModal
